import { useEffect, useState } from "react";
import { GetUserByUserName } from "../services/UserService";
import { changePassword , ChangeLanguage } from "../services/AuthService";
import { GetEmployeeById } from "../services/EmployeeService";
import { GetMyRoles } from "../services/RoleService";
import { useLanguage } from "./LanguageContext"; // مسیر واقعی خودت

const FONT_STACK = "IRANSansWeb, Vazirmatn, sans-serif";

const TEXTS = {
    fa: {
        dir: "rtl",
        myProfile: "پروفایل من",
        manageAccount: "مدیریت اطلاعات حساب کاربری",
        active: "فعال",
        userInfo: "اطلاعات کاربری",
        adminNoInfo: "این اطلاعات برای کاربر ادمین قابل نمایش نیست",
        readOnlySection: "این بخش غیرقابل ویرایش است",
        firstName: "نام",
        lastName: "نام خانوادگی",
        username: "نام کاربری",
        phoneNumber: "شماره همراه",
        address: "آدرس",
        changePassword: "تغییر رمز عبور",
        changePasswordSub: "برای امنیت بیشتر رمز عبور خود را بروز نگه دارید",
        passwordHint1: "رمز عبور باید حداقل یک حرف بزرگ انگلیسی",
        passwordHint2: "و یک حرف کوچک انگلیسی",
        passwordHint3: "داشته باشد",
        newPassword: "رمز عبور جدید",
        confirmPassword: "تکرار رمز عبور",
        valid: "معتبر ✓",
        weak: "ضعیف",
        matches: "مطابقت دارد ✓",
        noMatch: "مطابقت ندارد",
        changing: "در حال تغییر...",
        loading: "در حال بارگذاری...",
        user: "کاربر",
        emptyDash: "—",
        toastEnterPassword: "رمز عبور جدید را وارد کنید",
        toastWeakPassword: "رمز عبور باید حرف بزرگ و کوچک انگلیسی داشته باشد",
        toastNoMatch: "رمز عبور و تکرار آن یکسان نیستند",
        toastSuccess: "رمز عبور با موفقیت تغییر کرد",
        toastFail: "خطا در تغییر رمز عبور",
        toastEmployeeError: "خطا در دریافت اطلاعات فروشنده",
        toastUserError: "خطا در دریافت اطلاعات کاربر",
        language: "زبان",
        languageSub: "زبان نمایش سیستم را انتخاب کنید",
        persian: "فارسی",
        arabic: "عربی",
        toastLangSuccess: "زبان با موفقیت تغییر کرد",
        toastLangFail: "خطا در تغییر زبان",
        role: "نقش",
    },
    ar: {
        dir: "rtl",
        myProfile: "ملفي الشخصي",
        manageAccount: "إدارة معلومات الحساب",
        active: "نشط",
        userInfo: "معلومات المستخدم",
        adminNoInfo: "هذه المعلومات غير متاحة للمسؤول",
        readOnlySection: "هذا القسم غير قابل للتعديل",
        firstName: "الاسم",
        lastName: "اسم العائلة",
        username: "اسم المستخدم",
        phoneNumber: "رقم الهاتف",
        address: "العنوان",
        changePassword: "تغيير كلمة المرور",
        changePasswordSub: "للمزيد من الأمان، حافظ على تحديث كلمة المرور",
        passwordHint1: "يجب أن تحتوي كلمة المرور على حرف كبير واحد على الأقل",
        passwordHint2: "وحرف صغير واحد",
        passwordHint3: "",
        newPassword: "كلمة المرور الجديدة",
        confirmPassword: "تأكيد كلمة المرور",
        valid: "صالحة ✓",
        weak: "ضعيفة",
        matches: "متطابقة ✓",
        noMatch: "غير متطابقة",
        changing: "جارٍ التغيير...",
        loading: "جارٍ التحميل...",
        user: "مستخدم",
        emptyDash: "—",
        toastEnterPassword: "أدخل كلمة المرور الجديدة",
        toastWeakPassword: "يجب أن تحتوي كلمة المرور على حرف كبير وصغير",
        toastNoMatch: "كلمة المرور وتأكيدها غير متطابقين",
        toastSuccess: "تم تغيير كلمة المرور بنجاح",
        toastFail: "خطأ في تغيير كلمة المرور",
        toastEmployeeError: "خطأ في جلب معلومات البائع",
        toastUserError: "خطأ في جلب معلومات المستخدم",
        language: "اللغة",
        languageSub: "اختر لغة عرض النظام",
        persian: "الفارسية",
        arabic: "العربية",
        toastLangSuccess: "تم تغيير اللغة بنجاح",
        toastLangFail: "خطأ في تغيير اللغة",
        role: "الدور",
    },
};

function Icon({ name, size = 13, color = "currentColor" }) {
    const paths = {
        user: <><circle cx="12" cy="8" r="4" /><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" /></>,
        lock: <><rect x="5" y="11" width="14" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" /></>,
        eye: <><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z" /><circle cx="12" cy="12" r="3" /></>,
        "eye-off": <><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" /><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" /><line x1="1" y1="1" x2="23" y2="23" /></>,
        check: <><polyline points="20 6 9 17 4 12" /></>,
        phone: <><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.55 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" /></>,
        home: <><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></>,
        at: <><circle cx="12" cy="12" r="4" /><path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94" /></>,
        shield: <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></>,
        alert: <><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></>,
        globe: <><circle cx="12" cy="12" r="10" /><line x1="2" y1="12" x2="22" y2="12" /><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" /></>,
    };
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
            fill="none" stroke={color} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
            {paths[name] ?? null}
        </svg>
    );
}

function Toast({ message, visible, type }) {
    if (!visible) return null;
    return (
        <div style={{
            position: "fixed", bottom: 32, left: "50%", transform: "translateX(-50%)",
            background: type === "error" ? "#EF4444" : "#10B981",
            color: "#fff", padding: "10px 20px", borderRadius: 14,
            fontSize: 11, fontWeight: 500, zIndex: 1000,
            display: "flex", alignItems: "center", gap: 7,
            boxShadow: type === "error"
                ? "0 8px 24px rgba(239,68,68,.3)"
                : "0 8px 24px rgba(16,185,129,.3)",
        }}>
            <Icon name={type === "error" ? "alert" : "check"} size={13} color="#fff" />
            {message}
        </div>
    );
}

function PasswordInput({ value, onChange, placeholder }) {
    const [show, setShow] = useState(false);
    return (
        <div style={{ position: "relative" }}>
            <input
                type={show ? "text" : "password"}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                style={{
                    width: "100%", height: 38, border: "1.5px solid #E8ECF4",
                    borderRadius: 12, padding: "0 38px 0 12px", fontSize: 11,
                    fontFamily: FONT_STACK, direction: "rtl",
                    outline: "none", color: "#1E293B", boxSizing: "border-box",
                    background: "#F8FAFF", transition: "all .15s",
                }}
                onFocus={e => { e.target.style.borderColor = "#6C3DFF"; e.target.style.background = "#fff"; e.target.style.boxShadow = "0 0 0 4px rgba(108,61,255,.08)"; }}
                onBlur={e => { e.target.style.borderColor = "#E8ECF4"; e.target.style.background = "#F8FAFF"; e.target.style.boxShadow = "none"; }}
            />
            <button onClick={() => setShow(p => !p)} style={{
                position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)",
                background: "none", border: "none", cursor: "pointer", padding: 0,
                display: "flex", alignItems: "center",
            }}>
                <Icon name={show ? "eye-off" : "eye"} size={13} color="#94A3B8" />
            </button>
        </div>
    );
}

function SectionCard({ icon, title, subtitle, children, accent = "#6C3DFF" }) {
    return (
        <div style={{
            background: "#fff",
            borderRadius: 20,
            border: "1px solid #EEF2FF",
            overflow: "hidden",
            boxShadow: "0 1px 3px rgba(0,0,0,0.04), 0 4px 16px rgba(108,61,255,0.04)",
        }}>
            <div style={{
                padding: "16px 20px",
                borderBottom: "1px solid #F1F5F9",
                display: "flex", alignItems: "center", gap: 12,
                background: "linear-gradient(135deg, #FAFBFF 0%, #F5F3FF 100%)",
            }}>
                <div style={{
                    width: 36, height: 36, borderRadius: 11,
                    background: `linear-gradient(135deg, ${accent}18, ${accent}30)`,
                    display: "flex", alignItems: "center", justifyContent: "center",
                    flexShrink: 0,
                }}>
                    <Icon name={icon} size={15} color={accent} />
                </div>
                <div>
                    <p style={{ fontSize: 12, fontWeight: 600, color: "#1E293B", margin: 0 }}>{title}</p>
                    <p style={{ fontSize: 10, color: "#94A3B8", margin: "2px 0 0" }}>{subtitle}</p>
                </div>
            </div>
            <div style={{ padding: "20px" }}>{children}</div>
        </div>
    );
}

// سوییچ زبان — داخل کارت کاربر، کنار بج «فعال» (نه زیرش)
function MiniLanguageSwitch({ lang, changingLang, onChange, options }) {
    return (
        <div style={{
            display: "flex", alignItems: "center", gap: 4,
            background: "#F1F5F9", borderRadius: 999, padding: 3,
        }}>
            {options.map(opt => {
                const active = lang === opt.code;
                return (
                    <button
                        key={opt.code}
                        className="mini-lang-btn"
                        onClick={() => onChange(opt.code)}
                        disabled={changingLang}
                        style={{
                            height: 26, padding: "0 12px",
                            borderRadius: 999, border: "none",
                            background: active ? "#6C3DFF" : "transparent",
                            color: active ? "#fff" : "#64748B",
                            fontFamily: FONT_STACK, fontSize: 11, fontWeight: 600,
                            cursor: changingLang ? "not-allowed" : "pointer",
                            display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
                            transition: "all .15s",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {changingLang && active && (
                            <div style={{
                                width: 10, height: 10, borderRadius: "50%",
                                border: "1.5px solid rgba(255,255,255,.4)", borderTopColor: "#fff",
                                animation: "spin .7s linear infinite",
                            }} />
                        )}
                        {opt.label}
                    </button>
                );
            })}
        </div>
    );
}

const isAdminUser = (u) => {
    const role = u?.role || u?.roleName || u?.Role || u?.RoleName || "";
    return String(role).toLowerCase() === "admin";
};

export default function Profile() {
    const { lang, setLang } = useLanguage();
    const t = TEXTS[lang] || TEXTS.fa;

    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [savingPass, setSavingPass] = useState(false);
    const [changingLang, setChangingLang] = useState(false);
    const [toast, setToast] = useState({ visible: false, message: "", type: "success" });
    const [isAdmin, setIsAdmin] = useState(false);
    const [roleName, setRoleName] = useState("");

    const [form, setForm] = useState({
        firstName: "", lastName: "", username: "", phoneNumber: "", address: "",
    });
    const [passForm, setPassForm] = useState({ newPassword: "", confirmPassword: "" });

    const showToast = (message, type = "success") => {
        setToast({ visible: true, message, type });
        setTimeout(() => setToast({ visible: false, message: "", type: "success" }), 3000);
    };

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const username =
                    localStorage.getItem("username") ||
                    localStorage.getItem("userName") ||
                    JSON.parse(localStorage.getItem("user") || "{}")?.username ||
                    JSON.parse(localStorage.getItem("user") || "{}")?.userName;
                if (!username) { setLoading(false); return; }

                const res = await GetUserByUserName(username);
                const data = res.data?.data ?? res.data;
                setUser(data);

                const admin = isAdminUser(data);
                setIsAdmin(admin);

                // گرفتن اسم رول(های) کاربر لاگین‌شده برای نمایش بالای صفحه پروفایل
                try {
                    const rolesRes = await GetMyRoles();
                    const rolesData = rolesRes.data?.data ?? rolesRes.data;
                    const rolesArr = Array.isArray(rolesData) ? rolesData : (rolesData ? [rolesData] : []);
                    const names = rolesArr
                        .map(r => (typeof r === "string" ? r : (r?.roleName || r?.name || r?.RoleName || r?.Name)))
                        .filter(Boolean);
                    setRoleName(names.join("، "));
                } catch (err) {
                    // eslint-disable-next-line no-console
                    console.error("[Profile] GetMyRoles failed:", err?.response?.status, err?.response?.data || err);
                    setRoleName("");
                }

                const baseUsername = data.userName || data.username || "";

                if (admin) {
                    setForm({
                        firstName: "", lastName: "", username: baseUsername,
                        phoneNumber: "", address: "",
                    });
                } else if (data.employeeId) {
                    try {
                        const employeeRes = await GetEmployeeById(data.employeeId);
                        const employee = employeeRes.data?.data ?? employeeRes.data;
                        setForm({
                            firstName: employee?.firstName || "",
                            lastName: employee?.lastName || "",
                            username: baseUsername,
                            phoneNumber: employee?.phoneNumber || "",
                            address: employee?.address || "",
                        });
                    } catch {
                        showToast(t.toastEmployeeError, "error");
                        setForm({
                            firstName: "", lastName: "", username: baseUsername,
                            phoneNumber: "", address: "",
                        });
                    }
                } else {
                    setForm({
                        firstName: data.firstName || "",
                        lastName: data.lastName || "",
                        username: baseUsername,
                        phoneNumber: data.phoneNumber || "",
                        address: data.address || "",
                    });
                }
            } catch {
                showToast(t.toastUserError, "error");
            } finally {
                setLoading(false);
            }
        };
        fetchUser();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChangePassword = async () => {
        if (!passForm.newPassword?.trim()) { showToast(t.toastEnterPassword, "error"); return; }
        if (!/(?=.*[A-Z])(?=.*[a-z])/.test(passForm.newPassword)) {
            showToast(t.toastWeakPassword, "error"); return;
        }
        if (passForm.newPassword !== passForm.confirmPassword) {
            showToast(t.toastNoMatch, "error"); return;
        }
        try {
            setSavingPass(true);
            await changePassword(passForm.newPassword);
            setPassForm({ newPassword: "", confirmPassword: "" });
            showToast(t.toastSuccess);
        } catch {
            showToast(t.toastFail, "error");
        } finally {
            setSavingPass(false);
        }
    };

    const handleChangeLanguage = async (newLang) => {
        if (newLang === lang || changingLang) return;
        try {
            setChangingLang(true);
            await ChangeLanguage({ Language: newLang });
            setLang?.(newLang);
            showToast((TEXTS[newLang] || TEXTS.fa).toastLangSuccess);
        } catch {
            showToast(t.toastLangFail, "error");
        } finally {
            setChangingLang(false);
        }
    };

    const getInitials = (f, l) => `${f?.[0] || ""}${l?.[0] || ""}`.toUpperCase() || "?";

    const readOnlyInputStyle = {
        width: "100%", height: 38, border: "1.5px solid #E8ECF4",
        borderRadius: 12, padding: "0 12px", fontSize: 11,
        fontFamily: FONT_STACK, direction: "rtl",
        outline: "none", color: "#94A3B8", boxSizing: "border-box",
        background: "#F1F5F9", cursor: "not-allowed",
    };

    // نام، نام خانوادگی، نام کاربری و شماره همراه در یک ردیف؛ آدرس در ردیف بعدی به‌صورت تمام‌عرض
    const fieldGroups = [
        [
            { key: "firstName", label: t.firstName, icon: "user" },
            { key: "lastName", label: t.lastName, icon: "user" },
            { key: "username", label: t.username, icon: "at" },
            { key: "phoneNumber", label: t.phoneNumber, icon: "phone" },
        ],
        [
            { key: "address", label: t.address, icon: "home", full: true },
        ],
    ];

    const passOk = passForm.newPassword && /(?=.*[A-Z])(?=.*[a-z])/.test(passForm.newPassword);
    const passMatch = passForm.newPassword && passForm.confirmPassword && passForm.newPassword === passForm.confirmPassword;

    const languageOptions = [
        { code: "fa", label: t.persian },
        { code: "ar", label: t.arabic },
    ];

    if (loading) return (
        <div style={{
            minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
            background: "#F5F6FA", fontFamily: FONT_STACK,
        }}>
            <div style={{ textAlign: "center" }}>
                <div style={{
                    width: 40, height: 40, borderRadius: "50%",
                    border: "3px solid #EDE9FF", borderTopColor: "#6C3DFF",
                    animation: "spin .8s linear infinite", margin: "0 auto 14px",
                }} />
                <p style={{ color: "#94A3B8", fontSize: 11 }}>{t.loading}</p>
            </div>
            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
    );

    return (
        <div style={{
            fontFamily: FONT_STACK, direction: t.dir,
            minHeight: "100vh", background: "#F5F6FA",
        }}>
            <style>{`
                @keyframes spin { to { transform: rotate(360deg); } }
                @keyframes fadeUp { from { opacity:0; transform:translateY(12px); } to { opacity:1; transform:translateY(0); } }
                .pass-btn:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 6px 20px rgba(15,23,42,.25) !important; }
                .mini-lang-btn:hover:not(:disabled) { color: #6C3DFF !important; }
                .field-grid-quad { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; }
                .field-grid-full { display: grid; grid-template-columns: 1fr; gap: 12px; }
                .password-fields-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
                @media (max-width: 640px) {
                    .field-grid-quad { grid-template-columns: repeat(2, 1fr) !important; }
                    .password-fields-grid { grid-template-columns: 1fr !important; }
                    .pass-btn-row { justify-content: stretch !important; }
                    .pass-btn { width: 100%; justify-content: center !important; }
                }
            `}</style>

            <div style={{
                background: "linear-gradient(135deg, #6C3DFF 0%, #9B59FF 100%)",
                padding: "28px 28px 70px",
                position: "relative", overflow: "hidden",
            }}>
                <div style={{
                    position: "absolute", top: -60, left: -60, width: 220, height: 220,
                    borderRadius: "50%", background: "rgba(255,255,255,0.06)",
                }} />
                <div style={{
                    position: "absolute", bottom: -40, right: 80, width: 160, height: 160,
                    borderRadius: "50%", background: "rgba(255,255,255,0.04)",
                }} />
                <h1 style={{ fontSize: 18, fontWeight: 700, color: "#fff", margin: 0 }}>{t.myProfile}</h1>
                <p style={{ fontSize: 11, color: "rgba(255,255,255,0.65)", margin: "5px 0 0" }}>
                    {t.manageAccount}
                </p>
            </div>

            <div style={{ padding: "0 24px", marginTop: -42 }}>
                <div style={{
                    background: "#fff", borderRadius: 20, padding: "16px 20px",
                    display: "flex", alignItems: "center", gap: 16,
                    border: "1px solid #EEF2FF",
                    boxShadow: "0 4px 24px rgba(108,61,255,0.08)",
                    animation: "fadeUp .4s ease both",
                }}>
                    <div style={{
                        width: 60, height: 60, borderRadius: "50%",
                        background: "linear-gradient(135deg, #6C3DFF, #9B59FF)",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        fontSize: 20, fontWeight: 700, color: "#fff", flexShrink: 0,
                        boxShadow: "0 4px 16px rgba(108,61,255,.35)",
                    }}>
                        {isAdmin ? t.emptyDash : getInitials(form.firstName, form.lastName)}
                    </div>
                    <div style={{ flex: 1 }}>
                        <p style={{ fontSize: 15, fontWeight: 700, color: "#1E293B", margin: 0 }}>
                            {isAdmin
                                ? t.emptyDash
                                : (form.firstName || form.lastName
                                    ? `${form.firstName} ${form.lastName}`.trim()
                                    : t.user)}
                        </p>
                        <p style={{ fontSize: 11, color: "#94A3B8", margin: "4px 0 0", display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                            <span>@{form.username || t.emptyDash}</span>
                            {!!roleName && (
                                <span style={{
                                    display: "inline-flex", alignItems: "center", gap: 4,
                                    background: "#EEF2FF", color: "#6C3DFF",
                                    fontSize: 10, fontWeight: 600,
                                    padding: "2px 9px", borderRadius: 99,
                                }}>
                                    <Icon name="shield" size={10} color="#6C3DFF" />
                                    {roleName}
                                </span>
                            )}
                        </p>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <MiniLanguageSwitch
                            lang={lang}
                            changingLang={changingLang}
                            onChange={handleChangeLanguage}
                            options={languageOptions}
                        />
                        <div style={{
                            display: "flex", alignItems: "center", gap: 5,
                            background: "#ECFDF5", padding: "5px 10px", borderRadius: 99,
                        }}>
                            <div style={{ width: 5, height: 5, borderRadius: "50%", background: "#10B981" }} />
                            <span style={{ fontSize: 10, fontWeight: 600, color: "#059669" }}>{t.active}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div style={{
                padding: "18px 24px 100px",
                display: "flex", flexDirection: "column", gap: 18,
                animation: "fadeUp .5s .1s ease both",
            }}>
                <SectionCard
                    icon="lock"
                    title={t.userInfo}
                    subtitle={isAdmin ? t.adminNoInfo : t.readOnlySection}
                >
                    <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                        {fieldGroups.map((group, gi) => (
                            <div
                                key={gi}
                                className={group[0]?.full ? "field-grid-full" : "field-grid-quad"}
                            >
                                {group.map(f => (
                                    <div key={f.key}>
                                        <div style={{
                                            display: "flex", alignItems: "center", gap: 5,
                                            marginBottom: 6,
                                        }}>
                                            <Icon name={f.icon} size={11} color="#94A3B8" />
                                            <label style={{ fontSize: 10, fontWeight: 600, color: "#475569" }}>
                                                {f.label}
                                            </label>
                                        </div>
                                        <input
                                            value={isAdmin ? t.emptyDash : (form[f.key] || t.emptyDash)}
                                            disabled
                                            readOnly
                                            style={readOnlyInputStyle}
                                        />
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </SectionCard>

                <SectionCard icon="shield" title={t.changePassword} subtitle={t.changePasswordSub} accent="#0F172A">
                    <div style={{
                        background: "#F8FAFF", border: "1px solid #EEF2FF",
                        borderRadius: 12, padding: "10px 12px", marginBottom: 18,
                        display: "flex", alignItems: "flex-start", gap: 8,
                    }}>
                        <Icon name="lock" size={13} color="#6C3DFF" />
                        <p style={{ fontSize: 10, color: "#64748B", margin: 0, lineHeight: 1.7 }}>
                            {t.passwordHint1} <strong style={{ color: "#6C3DFF" }}>(A-Z)</strong> {t.passwordHint2}{" "}
                            <strong style={{ color: "#6C3DFF" }}>(a-z)</strong> {t.passwordHint3}
                        </p>
                    </div>

                    <div className="password-fields-grid">
                        <div>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6 }}>
                                <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                                    <Icon name="lock" size={11} color="#0F172A" />
                                    <label style={{ fontSize: 10, fontWeight: 600, color: "#475569" }}>{t.newPassword}</label>
                                </div>
                                {passForm.newPassword && (
                                    <span style={{
                                        fontSize: 9, fontWeight: 600, padding: "2px 7px", borderRadius: 99,
                                        background: passOk ? "#ECFDF5" : "#FEF2F2",
                                        color: passOk ? "#059669" : "#DC2626",
                                    }}>
                                        {passOk ? t.valid : t.weak}
                                    </span>
                                )}
                            </div>
                            <PasswordInput
                                value={passForm.newPassword}
                                onChange={e => setPassForm(p => ({ ...p, newPassword: e.target.value }))}
                                placeholder={t.newPassword}
                            />
                        </div>

                        <div>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6 }}>
                                <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                                    <Icon name="lock" size={11} color="#0F172A" />
                                    <label style={{ fontSize: 10, fontWeight: 600, color: "#475569" }}>{t.confirmPassword}</label>
                                </div>
                                {passForm.confirmPassword && (
                                    <span style={{
                                        fontSize: 9, fontWeight: 600, padding: "2px 7px", borderRadius: 99,
                                        background: passMatch ? "#ECFDF5" : "#FEF2F2",
                                        color: passMatch ? "#059669" : "#DC2626",
                                    }}>
                                        {passMatch ? t.matches : t.noMatch}
                                    </span>
                                )}
                            </div>
                            <PasswordInput
                                value={passForm.confirmPassword}
                                onChange={e => setPassForm(p => ({ ...p, confirmPassword: e.target.value }))}
                                placeholder={t.confirmPassword}
                            />
                        </div>
                    </div>

                    <div className="pass-btn-row" style={{ marginTop: 18, display: "flex", justifyContent: "flex-end" }}>
                        <button
                            className="pass-btn"
                            onClick={handleChangePassword}
                            disabled={savingPass}
                            style={{
                                height: 38, background: savingPass ? "#475569" : "#0F172A",
                                border: "none", borderRadius: 12, color: "#fff",
                                fontSize: 11, fontFamily: FONT_STACK,
                                fontWeight: 600, cursor: savingPass ? "not-allowed" : "pointer",
                                padding: "0 28px", transition: "all .2s",
                                display: "flex", alignItems: "center", gap: 7,
                                boxShadow: "0 4px 14px rgba(15,23,42,.2)",
                            }}
                        >
                            {savingPass ? (
                                <>
                                    <div style={{
                                        width: 12, height: 12, borderRadius: "50%",
                                        border: "2px solid rgba(255,255,255,.4)", borderTopColor: "#fff",
                                        animation: "spin .7s linear infinite",
                                    }} />
                                    {t.changing}
                                </>
                            ) : (
                                <>
                                    <Icon name="shield" size={13} color="#fff" />
                                    {t.changePassword}
                                </>
                            )}
                        </button>
                    </div>
                </SectionCard>
            </div>

            <Toast message={toast.message} visible={toast.visible} type={toast.type} />
        </div>
    );
}